export const environment = {
  production: true,
  ApiUrl: 'https://id.onf.ru',
  auth: {
    grantTypeAccess: 'secret_code',
    grantTypeRefresh: 'refresh_token',
    clientId: 'onfhelp',
    redirectUri: 'https://pomosch.onf.ru',
    scope: 'name phone email birthday region password chd photo',
    appToken: '',
    client_secret: '',
  },
  captcha: 'ysc1_eLYGV9FuIdApBdtn4MRdTignO8KAa1C8e3phpcOK3ff42269'
};
